import classNames from 'classnames'
import { CenteredLayout } from '#widgets/layouts/centered-layout'
import styles from './loading.module.scss'

interface LoadingProps {
  isFinishing?: boolean
}

export default function Loading({ isFinishing }: LoadingProps) {
  return (
    <CenteredLayout>
      <div className={classNames(styles.root, isFinishing && styles.rootFinishing)}></div>
    </CenteredLayout>
  )
}
